export default __webpack_public_path__ + "static/media/rankpage-top3.c58cd54b.svg";